import { updateFormFilterFacets } from "../../Shared/Utilities/filterFacets";

const employeeList = document.getElementById("employee-list");

if (!employeeList) {
  throw "Employee list missing";
}

const form = employeeList.querySelector<HTMLFormElement>("form");

if (!form) {
  throw "Employee list form missing";
}

const filterDropdowns = form.querySelectorAll<HTMLElement>("[data-filter-dropdown]");

filterDropdowns.forEach(filterDropdown => {
  const select = filterDropdown.querySelector("select");

  if (select) {
    select.addEventListener("change", async _ => {
      // Submit the form whenever a filter is updated
      form.requestSubmit();
    });
  }
});

htmx.on(form, "htmx:afterOnLoad", _ => {
  updateFormFilterFacets(form);
});
